import {
    CompanySpacesReportingStudyTimesContentsGetRequest,
    CompanySpacesReportingStudyTimesStudentsGetRequest,
    CompanySpacesReportingTestAnswersGetRequest,
    CompanySpacesReportingTestAttemptsGetRequest,
    StudyTimeApi,
    TestAnswerApi,
    TestAttemptApi
} from "../generated-api";
import {API_CONFIG} from "app/api-config";
import {createAsyncThunk} from "@reduxjs/toolkit";
import {withIgnoreErrorCodes} from "store/index";

const studyTimeApi = new StudyTimeApi(API_CONFIG);
const testAttemptApi = new TestAttemptApi(API_CONFIG);
const testAnswerApi = new TestAnswerApi(API_CONFIG);

export const fetchReportingStudyTimesStudents = createAsyncThunk('reporting/study-times/students', async (args: CompanySpacesReportingStudyTimesStudentsGetRequest) => {
    return await studyTimeApi.companySpacesReportingStudyTimesStudentsGet(args, withIgnoreErrorCodes({'401': null}));
});
export const fetchReportingStudyTimesStudentsXls = createAsyncThunk('reporting/study-times/students/xls', async (args: CompanySpacesReportingStudyTimesStudentsGetRequest) => {
    return await studyTimeApi.companySpacesReportingStudyTimesStudentsXlsxGetRaw(args, withIgnoreErrorCodes({'401': null}));
});

export const fetchReportingStudyTimesContents = createAsyncThunk('reporting/study-times/contents', async (args: CompanySpacesReportingStudyTimesContentsGetRequest) => {
    return await studyTimeApi.companySpacesReportingStudyTimesContentsGet(args, withIgnoreErrorCodes({'401': null}));
});

export const fetchReportingStudyTimesContentsXls = createAsyncThunk('reporting/study-times/contents/xls', async (args: CompanySpacesReportingStudyTimesContentsGetRequest) => {
    return await studyTimeApi.companySpacesReportingStudyTimesContentsXlsxGetRaw(args, withIgnoreErrorCodes({'401': null}));
});

export const fetchReportingTestAttempts = createAsyncThunk('reporting/test-attempts', async (args: CompanySpacesReportingTestAttemptsGetRequest) => {
    return await testAttemptApi.companySpacesReportingTestAttemptsGet(args, withIgnoreErrorCodes({'401': null}));
});

export const fetchReportingTestAttemptsXls = createAsyncThunk('reporting/test-attempts/xls', async (args: CompanySpacesReportingTestAttemptsGetRequest) => {
    return await testAttemptApi.companySpacesReportingTestAttemptsXlsxGetRaw(args, withIgnoreErrorCodes({'401': null}));
});

export const fetchReportingTestAnswers = createAsyncThunk('reporting/test-answers', async (args: CompanySpacesReportingTestAnswersGetRequest) => {
    return await testAnswerApi.companySpacesReportingTestAnswersGet(args, withIgnoreErrorCodes({'401': null}));
});

export const fetchReportingTestAnswersXls = createAsyncThunk('reporting/test-answers/xls', async (args: CompanySpacesReportingTestAnswersGetRequest) => {
    return await testAnswerApi.companySpacesReportingTestAnswersXlsxGetRaw(args, withIgnoreErrorCodes({'401': null}));
});

